import React, { FC, useEffect } from "react";
import Helmet from "react-helmet";
import { Container } from "@material-ui/core";
import useStyles from "./styles";
import { ToastContainer } from "react-toastify";

type Props = {
  title: string;
  className?: string;
  onPageLoad?: () => void;
};

const DPPageWrapper: FC<Props> = ({
  title,
  children,
  className = "",
  onPageLoad,
}) => {
  const classes = useStyles();

  useEffect(() => {
    onPageLoad && onPageLoad();
  }, [onPageLoad]);

  return (
    <Container fixed className={`${classes.page} ${className}`}>
      <Helmet>
        <title>DailyPay Partner Portal — {title}</title>
      </Helmet>
      <ToastContainer
        position={"top-center"}
        hideProgressBar={true}
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      />
      {children}
    </Container>
  );
};

export default DPPageWrapper;
